/** Intake API DTOs aligned with C# SurveyIntakeDto, SurveyRunDto, etc. */

export interface CreateSurveyRunResponseDto {
  surveyRunId: number;
  token: string;
  expiresAtUtc: string;
}

export interface QuestionForIntakeDto {
  id: number;
  questionType: string;
  questionText: string;
  displayOrder: number;
  maxCharacterCount?: number;
  answers: AnswerForIntakeDto[];
}

export interface AnswerForIntakeDto {
  id: number;
  answerText: string;
  displayOrder: number;
  /** Optional; used in admin preview to show score next to each answer. */
  score?: number;
}

export interface SurveyForIntakeDto {
  surveyRunId: number;
  token: string;
  expiresAtUtc: string;
  surveyTypeName?: string;
  collectContactInfo: boolean;
  questions: QuestionForIntakeDto[];
}

export interface RefreshTokenResponseDto {
  token: string;
  expiresAtUtc: string;
}

export interface SurveyResponseItemDto {
  surveyQuestionId: number;
  surveyAnswerId?: number;
  freeFormText?: string;
}

export interface ContactInfoDto {
  name?: string;
  email?: string;
  phoneNumber?: string;
  businessName?: string;
}

/** Schema max lengths per C# ContactInfoLimits. */
export const CONTACT_INFO_LIMITS = {
  name: 200,
  email: 255,
  phoneNumber: 50,
  businessName: 200
} as const;

export interface SubmitSurveyRequestDto {
  token: string;
  responses: SurveyResponseItemDto[];
  contact?: ContactInfoDto;
}

/** Request to submit contact from the results page (after survey submit). */
export interface SubmitContactRequestDto {
  surveyRunId: number;
  token: string;
  contact: ContactInfoDto;
}

export interface SubmitSurveyResponseDto {
  totalScore: number;
  analysis?: string;
  callToActionDisplayText?: string;
  callToActionPromptFragment?: string;
}
